(function () {
  const toast = document.querySelector('[data-stock-limit-toast]');
  if (!toast) return;

  const textEl = toast.querySelector('[data-stock-limit-text]');
  const closeBtn = toast.querySelector('[data-stock-limit-close]');
  let hideTimer = null;

  const template =
    toast.dataset.messageTemplate ||
    'Not enough items available. Only __QTY__ left.';

  function hideToast() {
    toast.hidden = true;
    toast.classList.remove('is-visible');
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  function showToast(max) {
    if (!textEl) return;
    const qty = Number.isFinite(max) ? max : 0;
    textEl.textContent = template.replace('__QTY__', String(qty));
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 4500);
  }

  document.addEventListener('quantity:stock-limit', (event) => {
    showToast(event.detail && event.detail.max);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', hideToast);
  }
})();
